<template>
  <v-col class="shadow pl-1 pr-1" cols="12" xs="12" sm="12" md="7" lg="6" xl="6">
    <!-- Ticket shape -->
    <svg class="svg">
      <clipPath id="my-clip-path" clipPathUnits="objectBoundingBox">
        <path
          d="m0.077,1 c-0.026,-0.002,-0.032,-0.003,-0.035,-0.008 c-0.003,-0.005,-0.005,-0.907,-0.001,-0.947 c0.003,-0.036,0.004,-0.04,0.011,-0.042 c0.003,-0.001,0.072,-0.002,0.154,-0.002 l0.149,-0.001,0.008,0.012 c0.013,0.018,0.046,0.04,0.076,0.05 c0.032,0.011,0.055,0.014,0.1,0.014 c0.044,0,0.067,-0.003,0.1,-0.014 c0.031,-0.01,0.064,-0.032,0.077,-0.05 l0.008,-0.012,0.149,0.001 c0.161,0.001,0.16,0.001,0.164,0.011 c0.003,0.007,0.003,0.97,0,0.976 c-0.002,0.004,-0.005,0.006,-0.013,0.008 c-0.008,0.002,-0.109,0.003,-0.467,0.003 c-0.25,0,-0.466,0,-0.479,-0.001"
        />
      </clipPath>
    </svg>

    <!-- Content -->
    <div class="clipped mt-2">
      <v-col class="no-scroll pa-0 ma-0">
        <!-- Image -->
        <v-img :src="activity.picture" class="mt-15 mb-5" height="100">
          <v-row align="end" class="lightbox white--text pa-2 fill-height">
            <v-col>
              <h1>{{this.activity.name}}</h1>
            </v-col>
          </v-row>
        </v-img>

        <!-- Details -->
        <v-row class="pa-3">
          <v-col cols="6">
            <section class="pb-5">
              <div>{{ $translate('LOCATION') }}</div>
              <h3>{{activity.locationName}}</h3>
            </section>

            <section class="pb-5">
              <div>{{ $translate('DATE') }}</div>
              <h3>{{activity.date}}</h3>
            </section>

            <section class="pb-5">
              <div>{{ $translate('NOTE') }}</div>
              <h4>{{activity.note}}</h4>
            </section>
          </v-col>

          <v-col cols="6">
            <section class="pb-5">
              <div>{{ $translate('ORDERID') }}</div>
              <h3>{{activity.orderId}}</h3>
            </section>

            <section class="pb-5">
              <div>{{ $translate('TIME') }}</div>
              <h3>{{activity.time}}</h3>
            </section>
          </v-col>
        </v-row>

        <!-- Order items -->
        <v-col cols="9" class="mb-5 ml-5" v-if="activity.orderItems.length > 0">
          <v-list rounded>
            <template v-for="(product) in order.Products">
              <v-list-item>
                <v-list-item-content align="start">
                  <v-list-item-title v-text="product.ProductName"></v-list-item-title>
                </v-list-item-content>
                {{product.Quantity}}x
              </v-list-item>
            </template>
            <template v-for="(specialRequest) in order.SpecialRequests">
              <v-list-item>
                <v-list-item-content align="start">
                  <v-list-item-title v-text="specialRequest.SpecialRequest"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>

        <v-row v-else class="padding"></v-row>
      </v-col>

      <!-- QR Code -->
      <QRCode :value="activity.orderId" class="mb-10 ml-5 mt-3"/>
    </div>
  </v-col>
</template>

<script>
import QRCode from '@chenfengyuan/vue-qrcode';
import doRequest from '@/api/dssRequest';

export default {
  data() {
    return {
      activities_toggle: 'activities',
      rating: 1,
      history: false,
      order: [],
    };
  },
  components: {
    QRCode,
  },
  name: 'ActivityDetail',
  props: ['type', 'activity'],
  watch: {},
  computed: {},
  methods: {
    getOrderV2() {
      const payload = {
        OrderId: this.activity.orderId,
      };
      doRequest(
        (response) => {
          this.order = response.data;
        },
        (error) => {
        },
        'getOrderV2',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
  },
  created() {},
  mounted() {
    if (this.type === 'history') {
      this.history = true;
    }
    this.getOrderV2();
  },
};
</script>

<style scoped lang="scss">
.padding {
  height: 10em;
}
.center-text {
  text-align: center;
}
.no-scroll {
  overflow: hidden !important;
}
a {
  text-decoration: inherit;
  color: inherit;
  cursor: auto;
}
.svg {
  position: absolute;
  width: 0;
  height: 0;
}
.clipped {
  width: 100%;
  height: 100%;
  background: #88D2FA;
  background-size: cover;
  border-radius: 20px;
  border: 1px solid lightgray;
  -webkit-clip-path: url(#my-clip-path);
  clip-path: url(#my-clip-path);
  transform: "rotate(180deg)";
}
.shadow {
  filter: drop-shadow(5px 10px 5px rgba(0, 0, 0, 0.1));
}
</style>
